<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container mainPage"
  >
    <header-area />
    <div :class="readyAction ? 'ready-action' : ''" class="main">
      <div
        class="step"
        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
      >
        <div class="slogan web">
          <div class="intro mo-typo01">
            <span>We exist for the purpose of connecting and harmonizing </span>
          </div>
          <div class="intro mo-typo01">
            <span>Internet Technology with the world we live in.</span>
          </div>
        </div>

        <div class="slogan mobile">
          <div class="intro mo-typo01"><span>We exist for the</span></div>
          <div class="intro mo-typo01"><span>purpose of connecting and </span></div>
          <div class="intro mo-typo01"><span>harmonizing Internet </span></div>
          <div class="intro mo-typo01"><span>Technology with the world </span></div>
          <div class="intro mo-typo01"><span>we live in.</span></div>
        </div>
        <div class="weather mo-typo01">
          <span>
            <span class="wText"
              >{{ currentAdress[1] }} {{ currentAdress[2] }} {{ currentAdress[3] }}
              {{ new Date() | dateFormat("A h:mm") }}</span
            >
            <span class="temp">{{ temp ? temp + "℃" : "" }}</span>
            <span v-if="temp" class="emoji">
              <img v-if="temp > 30" src="@/assets/images/emoji_hot_face.png" alt="" />
              <img v-else-if="temp > 16" src="@/assets/images/emoji_sm_face.png" alt="" />
              <img v-else-if="temp > 0" src="@/assets/images/emoji_cool_face.png" alt="" />
              <img v-else src="@/assets/images/emoji_freezing_face.png" alt="" />
            </span>
          </span>
        </div>

        <div
          class="blend step"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <div class="svg-blend">
            <div class="conTextArea">
              <div class="stick" :class="readyAction ? 'ready-action' : ''" />
              <div class="defaultSect2Text bic bic1" :class="readyAction ? 'ready-action' : ''">
                <span class="type1">a<em>Blend of</em></span>
                <span class="type2 other">Experience</span>
                <span class="type5">and Youth</span>
              </div>
            </div>
          </div>
          <div class="movie sc" ref="mainMovie"></div>
        </div>
      </div>

      <!-- who we are -->
      <div
        class="defaultSect who-we-are bdbLine step"
        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
      >
        <div class="divInner p-sm2">
          <div class="conText">
            <strong class="innerTitle mo-typo01"><span>Who we are</span></strong>

            <div class="conTextArea">
              <strong class="conTextTit web mo-typo01">
                <span v-html="$t('main.whoWeAre.title.pc[0]')" /><br />
                <span v-html="$t('main.whoWeAre.title.pc[1]')" />
              </strong>

              <strong class="conTextTit mobile mo-typo01">
                <span> {{ $t("main.whoWeAre.title.mo[0]") }} </span><br />
                <span v-html="$t('main.whoWeAre.title.mo[1]')" /><br />
                <span v-html="$t('main.whoWeAre.title.mo[2]')" />
              </strong>

              <span class="conTextin">
                {{ $t("main.whoWeAre.content[0]") }}
                <br />
                -
                <br />
                A blend of Experience and Youth.<br />
                {{ $t("main.whoWeAre.content[1]") }}
              </span>
            </div>
          </div>
          <div
            class="rightSince mo-typo01"
            v-observe-visibility="(isVisible, entry) => sinceObserveActive(isVisible, entry)"
          >
            <span
              >Since <span class="redPoint">{{ sincePlay.score }}</span>
              <span class="ico_area">
                <img src="@/assets/images/ico_since.png" alt="" />
              </span>
            </span>
          </div>
        </div>
      </div>
      <!-- //who we are -->

      <!-- 210127 works add -->
      <div
        class="defaultSect works_main bdbLine step"
        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
      >
        <div class="divInner p-sm2">
          <div class="conText">
            <div
              class="step"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <strong class="innerTitle mo-typo01"><span>Works</span></strong>

              <div class="conTextArea">
                <strong class="conTextTit web mo-typo01">
                  <span v-html="$t('main.worksMain.title.pc[0]')" /><br />
                  <span v-html="$t('main.worksMain.title.pc[1]')" />
                </strong>

                <strong class="conTextTit mobile mo-typo01">
                  <span> {{ $t("main.worksMain.title.mo[0]") }} </span><br />
                  <span v-html="$t('main.worksMain.title.mo[1]')" />
                </strong>
              </div>
            </div>
          </div>

          <div
            class="img_works"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="img_work_main">
              <div class="work_main_wrap">
                <span class="work_main_move"
                  ><marquee-text :duration="15"
                    >&nbsp;KOREA Stock Market No.1 Kiwoom</marquee-text
                  ></span
                >
                <img src="@/assets/images/works_view/kiwoom/img_kiwoom_main.png" alt="" />
              </div>
            </div>

            <div class="conTextArea">
              <a href="/works/kiwoom" class="pnikLink">
                <span class="linkText">Kiwoom Securities PC / Mobile web</span>
                <span class="linkIcon">
                  <img src="@/assets/images/@pink_arrow.svg" alt="" />
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- //210127 works add -->

      <!-- service -->
      <div
        class="service bdbLine step"
        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
      >
        <div class="divInner p-sm2">
          <div class="conText">
            <strong class="innerTitle mo-typo01"><span>Service</span></strong>
            <div class="conTextArea">
              <strong class="conTextTit web mo-typo01">
                <span v-html="$t('main.service.title.pc[0]')" /><br />
                <span v-html="$t('main.service.title.pc[1]')" />
              </strong>

              <strong class="conTextTit mobile mo-typo01">
                <span v-html="$t('main.service.title.mo[0]')" /><br />
                <span v-html="$t('main.service.title.mo[1]')" /><br />
                <span v-html="$t('main.service.title.mo[2]')" />
              </strong>
            </div>
          </div>
        </div>

        <div class="serviceList swiper-container">
          <ul class="swiper-wrapper">
            <li class="swiper-slide">
              <div class="serviceImg">
                <img src="@/assets/images/@service_img_00.jpg" alt="" />
              </div>
              <div class="serviceInfo">
                <dl>
                  <dt>{{ $t("main.service.content[0]") }}</dt>
                  <dd>PC&Mobile Web/App Development</dd>
                  <dd>e-Commerce Development</dd>
                  <dd>Omni-Channel Development</dd>
                  <dd>UI/UX/CX Design Strategy</dd>
                  <dd>SEM/SEO</dd>
                  <dd>Web Standardization & Accessibility</dd>
                </dl>
              </div>
            </li>
            <li class="swiper-slide">
              <div class="serviceImg">
                <img src="@/assets/images/@service_img_01.jpg" alt="" />
              </div>
              <div class="serviceInfo">
                <dl>
                  <dt>{{ $t("main.service.content[1]") }}</dt>
                  <dd>Digital IMC</dd>
                  <dd>Campaign & Promotion Management</dd>
                  <dd>Offline Promotion</dd>
                  <dd>Social Media Marketing</dd>
                  <dd>Online / Mobile AD</dd>
                  <dd>Contents Marketing</dd>
                </dl>
              </div>
            </li>
            <li class="swiper-slide">
              <div class="serviceImg">
                <img src="@/assets/images/@service_img_02.jpg" alt="" />
              </div>
              <div class="serviceInfo">
                <dl>
                  <dt>{{ $t("main.service.content[2]") }}</dt>
                  <dd>Web/Mobile Service Maintenance</dd>
                  <dd>Datadriven Maintenance</dd>
                  <dd>Content Maintenance</dd>
                  <dd>SEO Updates</dd>
                  <dd>Optimisation and Reporting</dd>
                  <dd>Data Analysis</dd>
                </dl>
              </div>
            </li>
          </ul>

          <!-- Add Pagination -->
          <div class="swiper-pagination rollDot tablet" />
        </div>
      </div>
      <!-- //service -->

      <!-- awards -->
      <div
        class="defaultSect2 awards step"
        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
      >
        <div class="divInner p-sm2">
          <div class="conText">
            <div
              class="step"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <strong class="innerTitle mo-typo01"><span>Awards</span></strong>

              <div class="conTextArea">
                <div class="defaultSect2Text">
                  <p class="mo-typo01 block type1">
                    <span>We<em>always</em></span>
                  </p>
                  <p class="mo-typo01 block type2"><span>show the best</span></p>
                  <p class="mo-typo01 block type2"><span>performance and</span></p>
                  <p class="mo-typo01 block"><span>leadership.</span></p>
                </div>
              </div>
            </div>
            <div
              class="awardsImgArea"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="awardsBg imgIntro">
                <span class="web">
                  <img src="@/assets/images/@awards_img_01.jpg" alt="" />
                </span>

                <span class="mobile">
                  <img src="@/assets/images/@awards_img_01_m.jpg" alt="" />
                </span>
              </div>
              <div
                class="rightWinner"
                v-observe-visibility="(isVisible, entry) => awardObserveActive(isVisible, entry)"
              >
                <span>
                  <span class="redPoint">{{ awardPlay.score }}</span> winner
                </span>

                <span class="ico_area">
                  <img src="@/assets/images/ico_winner.png" alt="" />
                </span>
                <span class="ico_area">
                  <img src="@/assets/images/ico_winner.png" alt="" />
                </span>
                <span class="ico_area">
                  <img src="@/assets/images/ico_winner.png" alt="" />
                </span>
              </div>
            </div>
          </div>

          <div
            class="listConArea mgtTop mo-content01 step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <strong class="topYear">{{ award.data[0].years }}</strong>
            <div class="listContnets mgbTop">
              <div v-for="(list, idx) in award.data[0].list" :key="idx" class="listArray">
                <p class="listTitle">{{ list.target }}</p>
                <ul>
                  <li v-for="(itm, i) in list.content" :key="'sub-' + i">
                    <span class="listName">{{ itm.subject }}</span>
                    <span class="listType" v-html="itm.awarded" />
                  </li>
                </ul>
              </div>
            </div>
            <a href="javascript:;" class="logoMore" @click.prevent="showAwads">
              <img src="@/assets/images/@ico_more.svg" alt="" />
              <span>more</span>
            </a>
          </div>
        </div>
      </div>
      <!-- //awards -->

      <!-- mid visual -->
      <div
        class="blend ver2 mgt0 step"
        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
      >
        <div class="movie imgIntro">
          <span class="web">
            <img src="@/assets/images/@culture_img_00.jpg" alt="" />
          </span>
          <span class="mobile">
            <img src="@/assets/images/@culture_img_00_m.jpg" alt="" />
          </span>
        </div>
        <div class="svg-blend">
          <div class="conTextArea">
            <div class="defaultSect2Text bic bic2">
              <span class="type1">We<em>value</em> the</span>
              <span class="new_type1">individuality</span>
              <span class="new_type2">of our members.</span>
            </div>
          </div>
        </div>
      </div>
      <!-- //mid visual -->

      <!-- culture -->
      <div
        class="defaultSect culture bdbLine step"
        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
      >
        <div class="divInner p-sm2">
          <div class="conText">
            <strong class="innerTitle mo-typo01"><span>Culture</span></strong>

            <div class="conTextArea">
              <strong class="conTextTit mo-typo01">
                <span> {{ $t("main.culture.title[0]") }} </span><br />
                <span>
                  {{ $t("main.culture.title[1]") }}
                </span>
              </strong>

              <span class="conTextin ver2">
                {{ $t("main.culture.content") }}
              </span>

              <!--
              컬처페이지 팝업으로 걸때, 하기의 a태그에 추가
              href="https://www.pulip.com/culture"
              @click.prevent="showCulture"
              -->

              <a href="/culturepage" class="pnikLink" alt="culture">
                <!-- SUB Link Test : 2021-06-08
                <span class="linkText" title="Culture">Experience for PULIP culture</span>
                -->
                <span class="linkText" title="Experience for PULIP culture"
                  >Experience for PULIP culture</span
                >
                <span class="linkIcon">
                  <img src="@/assets/images/@pink_arrow.svg" alt="" />
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- //culture -->

      <!-- ourTeam -->
      <div class="defaultSect2 ourTeam bdbLine">
        <div
          class="divInner p-sm2 step"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <div class="conText">
            <strong class="innerTitle mo-typo01"><span>Our Team</span></strong>

            <div class="conTextArea">
              <div class="defaultSect2Text">
                <p class="mo-typo01 block"><span>We are exertive</span></p>
                <p class="mo-typo01 block type1"><span>digital experts.</span></p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="divInner p-sm2 step"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <div class="conText rolling">
            <div class="rollContent">
              <div class="rollCon_inr">
                <div class="swiper-container">
                  <ul class="swiper-wrapper">
                    <li class="swiper-slide">
                      <span>
                        <img src="@/assets/images/@team_img_00.jpg" alt="" />
                      </span>
                    </li>
                    <li class="swiper-slide">
                      <span>
                        <img src="@/assets/images/@team_img_01.jpg" alt="" />
                      </span>
                    </li>
                    <li class="swiper-slide">
                      <span>
                        <img src="@/assets/images/@team_img_02.jpg" alt="" />
                      </span>
                    </li>
                    <li class="swiper-slide">
                      <span>
                        <img src="@/assets/images/@team_img_03.jpg" alt="" />
                      </span>
                    </li>
                    <li class="swiper-slide">
                      <span>
                        <img src="@/assets/images/@team_img_04.jpg" alt="" />
                      </span>
                    </li>
                    <li class="swiper-slide">
                      <span>
                        <img src="@/assets/images/@team_img_05.jpg" alt="" />
                      </span>
                    </li>
                  </ul>
                </div>

                <div class="rollNavi">
                  <!-- Add Pagination -->
                  <div class="swiper-pagination" />
                  <!-- Add Arrows -->
                  <div class="button-next">
                    <a href="javascript:;" @click.prevent="ourTeamSlideNext">
                      <img src="@/assets/images/@roll_right.svg" alt="" />
                    </a>
                  </div>
                  <div class="button-prev">
                    <a href="javascript:;" @click.prevent="ourTeamSlidePrev">
                      <img src="@/assets/images/@roll_left.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="divInner p-sm2 teamText step"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <div class="conText">
            <strong v-if="false" class="innerTitle mo-typo01"><span>&nbsp;</span></strong>
            <div class="conTextArea">
              <strong class="conTextTit web mo-typo01">
                <span> {{ $t("main.ourteam.title.pc[0]") }} </span><br />
                <span>
                  {{ $t("main.ourteam.title.pc[1]") }}
                  <span class="ico_span">
                    <img src="@/assets/images/@ico_hand.png" alt="" />
                  </span>
                </span>
              </strong>

              <strong class="conTextTit ver2 mobile mo-typo01">
                <span>{{ $t("main.ourteam.title.mo[0]") }}</span
                ><br />
                <span v-html="$t('main.ourteam.title.mo[1]')" /><br />
                <span>
                  {{ $t("main.ourteam.title.mo[2]") }}
                  <span class="ico_span">
                    <img src="@/assets/images/@ico_hand.jpg" alt="" />
                  </span>
                </span>
              </strong>

              <span class="conTextin web" v-html="$t('main.ourteam.content[0]')" />

              <span class="conTextin ver2 mobile" v-html="$t('main.ourteam.content[1]')" />

              <router-link :to="{ name: 'contact' }" class="pnikLink">
                <span class="linkText">Work with us</span>
                <span class="linkIcon">
                  <img src="@/assets/images/@pink_arrow.svg" alt="" />
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- //ourTeam -->

      <!-- partners -->
      <div
        class="partners bdbLine step"
        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
      >
        <div class="divInner p-sm2">
          <div class="conText">
            <strong class="innerTitle mo-typo01"><span>Partners</span></strong>

            <div class="conTextArea">
              <div class="partnersLogo mo-content01">
                <transition-group tag="ul" name="fade">
                  <li v-for="(partner, idx) in partnersList" :key="idx">
                    <img :src="imglink(partner.thumb)" :alt="partner.title" />
                  </li>
                </transition-group>
                <a
                  v-if="partnersLimit < partners.data.length"
                  href="javascript:;"
                  class="logoMore"
                  @click.prevent="partnersMore"
                >
                  <img src="@/assets/images/@ico_more.svg" alt="" />
                  <span>more</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- //partners -->

      <router-link
        :to="{ name: 'works' }"
        class="longEnd step"
        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
      >
        <div class="endDefault">
          <span>Works</span>
        </div>

        <div class="endTextArea">
          <div class="endText web">
            <span class="webBlock">
              {{ $t("main.footer.pc[0]") }}
            </span>
            <span class="webBlock">
              {{ $t("main.footer.pc[1]") }}
            </span>
          </div>

          <div class="endText mobile" v-html="$t('main.footer.mo')" />
        </div>

        <div class="engBg mainEndBg">
          <span />
        </div>
      </router-link>
    </div>
    <footer-area />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MarqueeText from "vue-marquee-text-component";
import award from "@/assets/json/award.json";
import partners from "@/assets/json/partners.json";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import waves from "vanta/dist/vanta.waves.min";
import { Expo, TweenLite } from "gsap/all";

export default {
  mixins: [common],
  name: "Main",
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        //{ property: 'og:image', content: this.pageImage },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.title }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText
  },
  data() {
    return {
      meta: {
        title: "플립커뮤니케이션즈",
        desc:
          "Together, we rise above and beyond. 우리는 사람과 IT가 더욱 가까워질 수 있도록 서로를 이어주는 연결고리가 되길 원합니다. 그렇기에 디지털 세상에 일상을 보다 멋지고 조화롭게 담아내고, 모두가 이용하기 편리하게 만들어 가는 데 집중합니다.",
        keywords:
          "웹에이전시, 디지털에이전시, 디자인에이전시, UIUX에이전시, 디자인회사, 금융권전문웹에이전시, 기업홈페이지제작업체, 기업웹사이트제작업체, 쇼핑몰제작업체, 반응형홈페이지제작업체, 모바일웹개발업체, 모바일앱개발업체, UIUX, 온라인마케팅, 온라인프로모션, 웹기획, 웹디자인, 웹개발, 웹퍼블리싱, 앱기획, 앱디자인, 앱개발, 앱퍼블리싱, 디자인가이드, 디자인시스템, 기업아이덴티티",
        url: "https://www.pulip.com"
      },
      sinceEnd: 1998,
      sincePlay: { score: 0, complete: true },
      awardPlay: { score: 0, complete: true },
      animation: false,
      activeIndex: "0",
      award,
      partners,
      outTeamSlider: null,
      servicelider: null,
      partnersLimit: 24,
      vantaEffect: null,
      vantaEffectOp: null
    };
  },
  computed: {
    ...mapState("common", {
      introVal: state => state.introVal,
      readyAction: state => state.readyAction,
      weather: state => state.weather,
      adress: state => state.adress,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    currentAdress() {
      return this.adress && this.adress.plus_code
        ? this.adress.plus_code.compound_code.split(" ")
        : "";
    },
    temp() {
      return this.weather && this.weather.main
        ? (Number(this.weather.main.temp) - 273.15).toFixed(0)
        : "";
    },
    partnersList() {
      return this.partners.data.slice(0, this.partnersLimit);
    },
    awardEnd() {
      let c = 0;
      this.award.data.map(itm => {
        itm.list.map(list => {
          list.content.map(_ => {
            c++;
          });
        });
      });
      return c;
    },
    routeQuery() {
      const { query = {} } = this.$route;
      return query;
    }
  },
  watch: {},
  methods: {
    ...mapActions("common", {
      setAwardsPopAction: "setAwardsPop",
      setLnbCopyAction: "setLnbCopy",
      getWeatherAction: "getWeather",
      getAdressAction: "getAdress",
      setReadyAction: "setReadyAction"
    }),
    partnersMore() {
      this.partnersLimit += 6;
    },
    showAwads() {
      this.setAwardsPopAction(true);
    },
    sinceObserveActive(isVisible) {
      if (isVisible) {
        if (this.sincePlay.complete) {
          this.sincePlay.complete = false;
          TweenLite.to(this.sincePlay, 3, {
            score: this.sinceEnd,
            roundProps: "score",
            ease: Expo.easeOut
          });
        }
      } else {
        this.sincePlay.score = 0;
        this.sincePlay.complete = true;
      }
    },
    awardObserveActive(isVisible) {
      if (isVisible) {
        if (this.awardPlay.complete) {
          this.awardPlay.complete = false;
          TweenLite.to(this.awardPlay, 3, {
            score: this.awardEnd,
            roundProps: "score",
            ease: Expo.easeOut
          });
        }
      } else {
        this.awardPlay.score = 0;
        this.awardPlay.complete = true;
      }
    },
    ourTeamSlideNext() {
      this.outTeamSlider.slideNext(300);
    },
    ourTeamSlidePrev() {
      this.outTeamSlider.slidePrev(300);
    }
  },
  mounted() {
    this.vantaEffectOp = {
      mouseControls: false,
      touchControls: true,
      gyroControls: false,
      scale: 1.0,
      scaleMobile: 2.0,
      color: 0x880012,
      shininess: 100.0,
      waveHeight: 10.0,
      waveSpeed: 2.0,
      zoom: 1
    };
    setTimeout(() => {
      this.vantaEffect = waves({
        el: this.$refs.mainMovie,
        ...this.vantaEffectOp
      });
    }, 1000);
    // setTimeout(() => {
    //   this.vantaEffectOp.color = 0x2b0070
    //   this.vantaEffect = waves({
    //     el: this.$refs.mainMovie,
    //     ...this.vantaEffectOp
    //   })
    // }, 3000)
    this.setReadyAction(true);
    this.setLnbCopyAction("0");
    // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition(position => {
    //     console.log(position.coords)
    //     this.getWeatherAction({ lat: position.coords.latitude, lon: position.coords.longitude })
    //     this.getAdressAction({ lat: position.coords.latitude, lon: position.coords.longitude })
    //   })
    // } else {
    this.getWeatherAction({ lat: 37.541, lon: 126.986 });
    // this.getAdressAction({ lat: 37.541, lon: 126.986 })
    // }
    this.outTeamSlider = new window.Swiper(".ourTeam .swiper-container", {
      loop: true,
      spaceBetween: 40,
      slidesPerView: "auto",
      observer: true,
      observeParents: true,
      pagination: {
        el: ".swiper-pagination",
        type: "fraction"
      },
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev'
      // },
      breakpoints: {
        891: {
          spaceBetween: 40
        },
        1: {
          spaceBetween: 15
        }
      }
    });
    this.serviceSlider = new window.Swiper(".serviceList.swiper-container", {
      pagination: {
        el: ".swiper-pagination"
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        1025: {
          slidesPerView: 3,
          spaceBetween: 40,
          touchRatio: 0
        },
        1: {
          slidesPerView: 1,
          spaceBetween: 15,
          touchRatio: 1
        }
      }
    });
    // 파라미터 분기
    if (this.$route.name === "team") this.showRecruit();
    if (this.$route.name === "project") this.showStartProject();
    if (this.$route.name === "culture") this.showCulture();
  },
  destroyed() {
    if (this.vantaEffect) {
      this.vantaEffect.destroy();
    }
    this.serviceSlider.destroy();
    this.outTeamSlider.destroy();
  }
};
</script>
